import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { parseJwt } from '@/api/auth';
import { menuAccessLevel } from '@/menu';

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { menuId: 'home' } },

  { path: '/onboarding-report', name: 'onboarding-report',
    component: () => import('../views/OnboardingReportView.vue'),
    meta: { menuId: 'reporte-operaciones' }
  },

  { path: '/onboarding-report-atc', name: 'onboarding-report-atc',
    component: () => import('../views/OnboardingReportATCView.vue'),
    meta: { menuId: 'reporte-atc' }
  },

  { path: '/user-report', name: 'user-report',
    component: () => import('../views/UserReportView.vue'),
    meta: { menuId: 'reporte-users' }
  },

  { path: '/onboarding-graficos', name: 'onboarding-graficos',
    component: () => import('../views/OnboardingGraficosView.vue'),
    meta: { menuId: 'analisis-datos' }
  },

  { path: '/config', name: 'config',
    component: () => import('../views/Config.vue'),
    meta: { menuId: 'configuraciones' }
  },

  { path: '/logging-report', name: 'logging-report',
    component: () => import('../views/LoggingReportView.vue'),
    meta: { menuId: 'reporte-logs' }
  },

  { path: '/audit-logs', name: 'audit-logs',
    component: () => import('../views/AuditLogsView.vue'),
    meta: { menuId: 'consulta-auditoria' } // note: id spelling matches your menu file
  },

  { path: '/blacklist-report', name: 'blacklist-report',
    component: () => import('../views/BlackListView.vue'),
    meta: { menuId: 'reporte-blacklist' }
  },

  { path: '/api-key', name: 'api-key',
    component: () => import('../views/ApiKeyForPartnersView.vue'),
    meta: { menuId: 'api-key' }
  },

  { path: '/login', name: 'login', component: () => import('../views/LoginView.vue') },
  { path: '/review', name: 'review', component: () => import('../views/ReviewView.vue'), meta: { menuId: 'aprobacion-manual' } },
  { path: '/manual-review-log', name: 'manual-review-log', component: () => import('../views/ManualReviewLogView.vue'), meta: { menuId: 'historial-revisiones' } },
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

function getAccessLevelFromToken() {
  const token = sessionStorage.getItem('access_token');
  if (!token) return '1'; // fallback for safety, though unauth is already handled

  const payload = parseJwt(token);
  const level = payload?.authority_level;

  // Explicit fallback to level "1"
  return level != null ? String(level) : '1';
}

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('access_token');

  if (!token && to.name !== 'login') {
    return next({ name: 'login', replace: true });
  }

  if (token && to.name === 'login') {
    return next({ name: 'home' });
  }

  const menuId = to.meta?.menuId;
  if (!menuId) return next();

  const authorityLevel = getAccessLevelFromToken();
  const allowedMenuIds =
    menuAccessLevel[authorityLevel] ?? menuAccessLevel['1'];

  if (!allowedMenuIds) {
    return next({ name: 'home' });
  }

  if (!allowedMenuIds.includes(menuId)) {
    return next({ name: 'home' });
  }

  return next();
});

export default router
